import { defineMessages } from "react-intl";

export const messages = defineMessages({
    resourcesTitle: {
        id: "fastshift.dashboard.migration-resources.title",
        defaultMessage: "Migration Resources",
        description: "Title for the migration resources section"
    },
    smartSearchCardTitle: {
        id: "fastshift.dashboard.migration-resources.smart-search-card.title",
        defaultMessage: "Self Help with Smart Search",
        description: "Title for the Smart Search self-help card"
    },
    smartSearchCardDescription: {
        id: "fastshift.dashboard.migration-resources.smart-search-card.description",
        defaultMessage:
            "Effortlessly find answers through our curated collection of help articles, providing practical tips and solutions for every phase of your cloud journey.",
        description: "Description for the Smart Search self-help card"
    },
    smartSearchCardButton: {
        id: "fastshift.dashboard.migration-resources.smart-search-card.button",
        defaultMessage: "Curated Knowledge Articles",
        description: "Button text for exploring Smart Search"
    },
    communityCardTitle: {
        id: "fastshift.dashboard.migration-resources.community-card.title",
        defaultMessage: "Interact and learn with Community",
        description: "Title for the Atlassian Community card"
    },
    communityCardDescription: {
        id: "fastshift.dashboard.migration-resources.community-card.description",
        defaultMessage:
            "Engage, learn, and grow through interactive courses and a vibrant community - ideal for enhancing your expertise and receiving support from fellow users.",
        description: "Description for the Atlassian Community card"
    },
    communityCardButton: {
        id: "fastshift.dashboard.migration-resources.community-card.button",
        defaultMessage: "Atlassian Community & Learning",
        description: "Button text for exploring the Atlassian Community"
    },
    cloudCardTitle: {
        id: "fastshift.dashboard.migration-resources.cloud-card.title",
        defaultMessage: "Quick Start on Atlassian Cloud",
        description: "Title for the Atlassian Cloud card"
    },
    cloudCardDescription: {
        id: "fastshift.dashboard.migration-resources.cloud-card.description",
        defaultMessage:
            "Access comprehensive step-by-step guides and resources to help you get started with Atlassian Cloud swiftly and confidently.",
        description: "Description for the Atlassian Cloud card"
    },
    cloudCardButton: {
        id: "fastshift.dashboard.migration-resources.cloud-card.button",
        defaultMessage: "Quick Start Guides",
        description: "Button text for exploring Atlassian Cloud resources"
    }
});
